import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon, MinusIcon } from "lucide-react";

import { cn } from "@/lib/utils";

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer group bg-fills-light inset-border-double dark:bg-input/30 data-[state=checked]:bg-primary-normal data-[state=indeterminate]:bg-primary-normal data-[state=checked]:text-static-white data-[state=indeterminate]:text-static-white dark:data-[state=checked]:bg-primary-normal dark:data-[state=indeterminate]:bg-primary-normal aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:inset-border-error size-5 shrink-0 rounded-sm transition-shadow outline-none disabled:cursor-not-allowed hover:bg-static-black/6 focus-visible:bg-static-black/10 active:bg-static-black/14 active:after:bg-static-black/14 disabled:bg-fills-strong disabled:data-[state=checked]:bg-labels-alternative disabled:data-[state=indeterminate]:bg-labels-alternative",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <CheckIcon className="hidden size-4 group-data-[state=checked]:block" />
        <MinusIcon className="hidden size-4 group-data-[state=indeterminate]:block" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
